import { render } from "./BindingInfoView.vue?vue&type=template&id=76f723a1&scoped=true"
import script from "./BindingInfoView.vue?vue&type=script&lang=js"
export * from "./BindingInfoView.vue?vue&type=script&lang=js"

import "./assets/index.css?vue&type=style&index=0&id=76f723a1&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f723a1"]])

export default __exports__